import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import inboundEmailKeys from './keyFactory';

const GetInboundEmailUnreadCount = graphql(`
  query InboundEmailUnreadCount {
    me {
      inboundEmailUnreadCount
    }
  }
`);

const useGetInboundEmailUnreadCount = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: inboundEmailKeys.unreadCount(),
    queryFn: () => {
      return gqlClient.request(GetInboundEmailUnreadCount);
    },
    refetchInterval: 60000, // Refetch every minute
    enabled: options?.enabled,
  });
};

export default useGetInboundEmailUnreadCount;
